import moment from "moment";
import React from "react";

type DateTimeSpanProps = {
    date: string;
};

const DateTimeSpan: React.FC<DateTimeSpanProps> = ({date}) => {
    let localDate = moment.utc(date, "DD-MM-YYYYTHH:mm")
        .local()
        .format("DD-MM-YYYY HH:mm");
    return (
        <span>{localDate}</span>
    )
}

export default DateTimeSpan;